import React from 'react';
import styles from '../shared/TipComponents.module.scss';

/* Interfaces */
import { TipProduct } from '../../interfaces/TipProduct';

/* Assets */
import SVG from 'react-inlinesvg';
import dropdown from '../../../../../assets/dropdown.svg';

interface OwnProps {
  tip: TipProduct;
  isTipster: boolean;
}

export const BookieButton: React.FC<OwnProps> = ({ tip, isTipster }) => {
  //   const { t } = useTranslation();
  const { bookie_button } = tip.tip;
  return (
    <div
      className={styles.bookieBtnWrapper}
      id={isTipster ? styles.tipsterBookieBtn : styles.unset}
    >
      <div
        className={styles.bookieBtnOuter}
        style={{
          backgroundColor: bookie_button.background_color,
        }}
      >
        <img src={bookie_button.logo_url} alt="bookie logo" />
        <a
          href={bookie_button.bookie_url}
          className={styles.bookieBtnInner}
          style={{
            color: bookie_button.button_text_color,
            backgroundColor: bookie_button.button_color,
          }}
        >
          {bookie_button.button_text}
          <SVG
            src={dropdown}
            style={{ fill: bookie_button.button_text_color }}
          />
        </a>
      </div>
    </div>
  );
};
